<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{hagr.fctitaal_oms}} {{hagr.hagr_bedrag}} from booking {{hagr.huov_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHagr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hagr_encrid: null,
      hagr: {}
    }
  },
  methods: {
    open(hagr_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/hagr/getHagr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHagr"
          },
          getHagr: {
            hagr_encrid: hagr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hagr = res.data.getHagr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHagr() { 
      this.$axios
        .post("ares/json/ares/huov/hagr/rmHagr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHagr"
          },
          rmHagr: {
            hagr_encrid: this.hagr.hagr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.rmHagr.huov_encrid); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHagr.text,
              color: res.data.rmHagr.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

